import styled from "styled-components";
import Props from "./interface/props";

const TabStyle = styled.div<Props>`
  background-color: ${({ backgroundColor }) =>
    backgroundColor || "rgba(255, 255, 255, 0)"};
  border-radius: ${({ borderRadius }) => borderRadius || ""};
  margin-bottom: ${({ marginBottom }) => marginBottom || ""};
  margin-left: ${({ marginLeft }) => marginLeft || ""};
  margin-right: ${({ marginRight }) => marginRight || ""};
  margin-top: ${({ marginTop }) => marginTop || ""};
  display: ${({ display }) => display || "flex"};
  flex-direction: ${({ flex_direction }) => flex_direction || ""};
  justify-content: ${({ justify_content }) => justify_content || ""};
  align-items: ${({ align_items }) => align_items || ""};
  width: ${({ width }) => width || ""};
  height: ${({ height }) => height || ""};
  color: ${({ color }) => color || ""};
  padding: ${({ padding }) => padding || ""};
  font-size: ${({ fontSize }) => fontSize || ""};
  position: ${({ position }) => position || ""};

  .select {
    color: #1976d2;
    border-bottom: 3px solid #1976d2;
    &:hover {
      background-color: #1976d250;
    }
  }

  @media screen and (max-width: 700px) {
    align-items: center;
    flex-direction: column;
    height: auto;
  }
`;

export default TabStyle;
